import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

interface HealthTrendChartProps {
  history: { date: string; score: number }[];
}

function formatDate(dateStr: string) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export default function HealthTrendChart({ history }: HealthTrendChartProps) {
  const data = [...history].reverse();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center gap-2 pb-2">
        <TrendingUp className="h-4 w-4 text-muted-foreground" />
        <CardTitle className="text-base">Health Trend (90 days)</CardTitle>
      </CardHeader>
      <CardContent>
        {data.length < 2 ? (
          <p className="text-sm text-muted-foreground py-8 text-center">
            Not enough data for trend chart. Scores are recorded daily.
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={200}>
            <AreaChart data={data}>
              <XAxis
                dataKey="date"
                tickFormatter={formatDate}
                tick={{ fontSize: 11 }}
              />
              <YAxis
                domain={[0, 100]}
                ticks={[0, 30, 50, 70, 100]}
                tick={{ fontSize: 11 }}
                width={30}
              />
              <Tooltip
                labelFormatter={formatDate}
                formatter={(value: number) => [value, "Score"]}
              />
              <ReferenceLine y={70} stroke="green" strokeDasharray="3 3" label="Healthy" />
              <ReferenceLine y={50} stroke="#eab308" strokeDasharray="3 3" label="Neutral" />
              <ReferenceLine y={30} stroke="orange" strokeDasharray="3 3" label="At Risk" />
              <Area
                type="monotone"
                dataKey="score"
                stroke="#1e3a5f"
                fill="#1e3a5f"
                fillOpacity={0.1}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
